import { AttachmentImageSize, EventLocationUseType, EventObserverActionUseType } from "../enums";
import { EditItem, IEditItem } from "./../common/editItem";
import { IModifyUser, ModifyUser } from "./../user/modifyUser";

export interface IEventSetting extends IEditItem {
    attachmentImageSize: AttachmentImageSize;
    observerActionUseType: EventObserverActionUseType;
    locationUseType: EventLocationUseType;
    modifyUser: IModifyUser;
}

export class EventSetting extends EditItem implements IEventSetting {
    attachmentImageSize: AttachmentImageSize;
    observerActionUseType: EventObserverActionUseType;
    locationUseType: EventLocationUseType;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IEventSetting);
    constructor(obj?: any) {
        super(obj);
        this.attachmentImageSize = obj && obj.attachmentImageSize || AttachmentImageSize.Large;
        this.observerActionUseType = obj && obj.observerActionUseType || EventObserverActionUseType.NotInUse;
        this.locationUseType = obj && obj.locationUseType || EventLocationUseType.NotInUse;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}